import { render, staticRenderFns } from "./StaticDocs.vue?vue&type=template&id=12345e81&scoped=true"
import script from "./StaticDocs.vue?vue&type=script&lang=js"
export * from "./StaticDocs.vue?vue&type=script&lang=js"
import style0 from "./StaticDocs.vue?vue&type=style&index=0&id=12345e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12345e81",
  null
  
)

export default component.exports